<template>
  <div class="ov-page">
    <div class="ov-header">
      <div>
        <div class="ov-header__kicker pg-kicker">Programmes de l'offre</div>
        <h1 class="ov-header__title">{{ offreVoyage.designation || '—' }}</h1>
        <div class="pg-head-route">
          <span>{{ offreVoyage.villeDepartDesignation || '—' }}</span>
          <span class="pg-head-route__line"></span>
          <span>{{ offreVoyage.villeDestinationDesignation || '—' }}</span>
          <span v-if="offreVoyage.typeOffreVoyageDesignation" class="ov-badge ov-badge--navy ov-badge--plain">
            {{ offreVoyage.typeOffreVoyageDesignation }}
          </span>
        </div>
      </div>
      <div class="ov-header__actions">
        <button type="button" class="ov-btn ov-btn--secondary" @click="$router.push('/selectionnerOffreVoyageReservation')">
          <v-icon small>mdi-arrow-left</v-icon>
          Offres
        </button>
        <button type="button" class="ov-btn ov-btn--primary" :disabled="!offreVoyage.designation" @click="toBookTicket(offreVoyage)">
          <v-icon small>mdi-ticket-confirmation-outline</v-icon>
          Nouvelle réservation
        </button>
      </div>
    </div>

    <div class="ov-grid">
      <!-- ===== PROGRAMMES ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">
            Programmes
            <span class="ov-count">{{ filteredProgrammeList.length }}</span>
          </div>
          <div class="pg-seg" role="group" aria-label="Filtrer les programmes">
            <button
              v-for="filter in filters"
              :key="filter.value"
              type="button"
              class="pg-seg__opt"
              :class="{ 'pg-seg__opt--active': programmeFilter === filter.value }"
              @click="programmeFilter = filter.value"
            >
              {{ filter.label }} <span>{{ filter.count }}</span>
            </button>
          </div>
        </div>

        <v-progress-linear v-if="loading" indeterminate color="#159e72" height="2"></v-progress-linear>

        <div v-if="!loading && filteredProgrammeList.length == 0" class="ov-card__body">
          <div class="ov-empty">
            {{ programmeFilter === 'expired' ? 'Aucun programme expiré.' : programmeFilter === 'active' ? 'Aucun programme en cours pour cette offre.' : 'Aucun programme pour cette offre.' }}
          </div>
        </div>

        <ul v-else class="pg-list">
          <li
            v-for="(programme, index) in filteredProgrammeList"
            :key="programme.id || programme.designation || index"
            class="pg-item"
            :class="{ 'pg-item--expired': programme.isExpired }"
          >
            <div class="pg-item__date">
              <div class="pg-item__day">{{ programme.dateDepart || '—' }}</div>
              <div v-if="programme.heureDepart" class="pg-item__hour">{{ programme.heureDepart }}</div>
            </div>

            <div class="pg-item__main">
              <div class="pg-item__title">{{ programme.designation }}</div>
              <div class="pg-item__meta">
                <span>Arrivée {{ programme.dateArrivee || '—' }}<template v-if="programme.heureArrivee"> · {{ programme.heureArrivee }}</template></span>
                <span>Bus {{ programme.numeroBus || '—' }}</span>
              </div>
            </div>

            <div class="pg-item__side">
              <span v-if="programme.isExpired" class="ov-badge ov-badge--neutral">Expiré</span>
              <template v-else>
                <span v-if="seats(programme) === 0" class="ov-badge ov-badge--danger">Complet</span>
                <span v-else-if="seats(programme) !== null" class="ov-badge ov-badge--success">
                  {{ seats(programme) }} place{{ seats(programme) > 1 ? 's' : '' }}
                </span>
              </template>
              <button
                type="button"
                class="ov-icon-btn"
                title="Exporter le rapport (PDF)"
                :disabled="exportingDesignation === programme.designation"
                @click="toExportReport(programme.designation)"
              >
                <v-progress-circular v-if="exportingDesignation === programme.designation" indeterminate size="14" width="2"></v-progress-circular>
                <v-icon v-else small>mdi-file-download-outline</v-icon>
              </button>
            </div>
          </li>
        </ul>
      </div>

      <!-- ===== RÉSUMÉ ===== -->
      <div class="ov-sticky">
        <div class="ov-card">
          <div class="ov-card__head">
            <div class="ov-card__title">Résumé</div>
          </div>
          <div class="ov-card__body">
            <div class="ov-stat">
              <span class="ov-stat__label">Programmes en cours</span>
              <span class="ov-stat__value ov-stat__value--accent">{{ activeCount }}</span>
            </div>
            <div class="ov-stat">
              <span class="ov-stat__label">Programmes expirés</span>
              <span class="ov-stat__value">{{ expiredCount }}</span>
            </div>
            <div class="ov-stat">
              <span class="ov-stat__label">Total</span>
              <span class="ov-stat__value">{{ programmeList.length }}</span>
            </div>
            <div v-if="offreVoyage.description" class="ov-note mt-4">{{ offreVoyage.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import {
  HEADERS,
  API_GENERATE_REPORT,
  API_RECUPERER_PROGRAMME_PAR_OFFRE_VOYAGE,
} from "../globalConfig/globalConstConfig";
import { showErrorMessage } from "@/modules/messages/messageProcess";
export default {
  name: "ProgrammeOffreVoyageList",
  data() {
    return {
      programmeFilter: "active",
      loading: true,
      exportingDesignation: null,
      errorMsg: null,
      offreVoyage: {
        id: null,
        designation: null,
        description: null,
        compagnieTransportRaisonSociale: null,
        typeOffreVoyageDesignation: null,
        villeDepartDesignation: null,
        villeDestinationDesignation: null,
      },

      offreVoyageObject: {
        data: {
          designation: null,
        },
      },

      reportGenerated: {
        data: {
          programmeDesignation: null,
        },
      },

      programmeList: [],
    };
  },

  computed: {
    activeCount() {
      if (!Array.isArray(this.programmeList)) return 0;
      return this.programmeList.filter((p) => p && p.isExpired !== true).length;
    },
    expiredCount() {
      if (!Array.isArray(this.programmeList)) return 0;
      return this.programmeList.filter((p) => p && p.isExpired === true).length;
    },
    filteredProgrammeList() {
      if (!Array.isArray(this.programmeList)) return [];
      if (this.programmeFilter === "expired") {
        return this.programmeList.filter((p) => p && p.isExpired === true);
      }
      if (this.programmeFilter === "all") {
        return this.programmeList;
      }
      return this.programmeList.filter((p) => p && p.isExpired !== true);
    },
    filters() {
      return [
        { value: 'active', label: 'En cours', count: this.activeCount },
        { value: 'expired', label: 'Expirés', count: this.expiredCount },
        { value: 'all', label: 'Tous', count: this.programmeList.length },
      ];
    },
  },

  methods: {
    // OUVRE LE PDF DANS UN NOUVEL ONGLET (les navigateurs bloquent les URL « data: »)
    openPdf(base64, fileName) {
      const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
      const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 15000);
    },

    // Places restantes : 0 est une vraie valeur (programme complet)
    seats(programme) {
      const value = programme.nombrePlaceDisponible;
      return value === null || value === undefined || value === "" ? null : Number(value);
    },

    //OBTENIR LA LISTE DES PROGRAMMES PAR OFFRE DE VOYAGE
    async getPlanningByOffersTravel() {
      await axios
        .post(
          API_RECUPERER_PROGRAMME_PAR_OFFRE_VOYAGE,
          this.offreVoyageObject,
          { headers: HEADERS(this.$store.state.userAuthentified.token) }
        )
        .then((response) => {
          if (response.data.status.code == 800) {
            this.programmeList = response.data.items || [];
          } else {
            this.programmeList = [];
          }
        })
        .catch((e) => {
          this.errorMsg = (e && e.message) || "Impossible de charger les programmes.";
          this.programmeList = [];
          showErrorMessage();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //Exporter le rapport en PDF
    async toExportReport(designationProgramme) {
      if (!designationProgramme || this.exportingDesignation) return;
      this.exportingDesignation = designationProgramme;
      this.reportGenerated.data.programmeDesignation = designationProgramme;
      await axios
        .post(API_GENERATE_REPORT, this.reportGenerated, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (designationProgramme == null) {
            this.$swal.fire(
              "Erreur",
              "Impossible de télécharger le rapport",
              "error"
            );
          } else if (response.data.hasError == true) {
            this.$swal.fire("Erreur", "Une erreur s'est produite", "error");
          } else {
            this.openPdf(response.data.item.contentBase64, `rapport-${designationProgramme}.pdf`);
          }
        })
        .catch((e) => {
          this.$swal.fire("Erreur", (e && e.message) || "Impossible de générer le rapport", "error");
        })
        .finally(() => {
          this.exportingDesignation = null;
        });
    },

    storeOffreVoyageItem(item) {
      const parsedOffreSelected = JSON.stringify(item);
      localStorage.setItem("offreVoyageSelected", parsedOffreSelected);
    },

    toBookTicket(offreVoyage) {
      this.storeOffreVoyageItem(offreVoyage);
      this.$router.push({ path: "/reservationBillet" });
    },

    async retrieveOffreSelected() {
      if (localStorage.getItem("offreVoyageSelected")) {
        try {
          const offreVoyageEditing = JSON.parse(
            localStorage.getItem("offreVoyageSelected")
          );
          this.offreVoyage.id = offreVoyageEditing.id;
          this.offreVoyage.designation = offreVoyageEditing.designation;
          this.offreVoyage.description = offreVoyageEditing.description;
          this.offreVoyage.typeOffreVoyageDesignation =
            offreVoyageEditing.typeOffreVoyageDesignation;
          this.offreVoyage.villeDepartDesignation =
            offreVoyageEditing.villeDepartDesignation;
          this.offreVoyage.villeDestinationDesignation =
            offreVoyageEditing.villeDestinationDesignation;
          this.offreVoyageObject.data.designation =
            this.offreVoyage.designation;
          await this.getPlanningByOffersTravel();
        } catch (error) {
          localStorage.removeItem("offreVoyageSelected");
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.retrieveOffreSelected();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.pg-kicker {
  margin-bottom: 4px;
}

.pg-head-route {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 14px;
  font-weight: 700;
  color: $ov-ink;
}

.pg-head-route__line {
  width: 26px;
  border-top: 2px dashed rgba(21, 158, 114, 0.55);
}

/* FILTRE SEGMENTÉ */
.pg-seg {
  display: inline-flex;
  padding: 3px;
  background: #f1f5f9;
  border-radius: 10px;
}

.pg-seg__opt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 13px;
  font-weight: 700;
  color: $ov-muted;
  cursor: pointer;

  span {
    font-size: 12px;
    color: $ov-subtle;
  }

  &--active {
    background: #ffffff;
    color: $ov-navy;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);

    span {
      color: $ov-green;
    }
  }
}

/* LISTE DES PROGRAMMES */
.pg-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pg-item {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 16px 22px;
  border-bottom: 1px solid $ov-line;
  transition: background 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: $ov-soft;
  }

  &--expired {
    .pg-item__day,
    .pg-item__hour,
    .pg-item__title {
      color: $ov-subtle;
    }
  }
}

.pg-item__date {
  flex-shrink: 0;
  width: 110px;
  padding-right: 16px;
  border-right: 1px solid $ov-line;
}

.pg-item__day {
  font-size: 14px;
  font-weight: 800;
  color: $ov-navy;
  font-variant-numeric: tabular-nums;
}

.pg-item__hour {
  font-size: 20px;
  font-weight: 900;
  color: $ov-green;
  font-variant-numeric: tabular-nums;
}

.pg-item__main {
  flex: 1;
  min-width: 0;
}

.pg-item__title {
  font-size: 14px;
  font-weight: 800;
  color: $ov-ink;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pg-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-top: 2px;
  font-size: 13px;
  color: $ov-muted;
}

.pg-item__side {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 760px) {
  .pg-item {
    flex-wrap: wrap;
    gap: 10px 14px;
    padding: 14px 16px;
  }

  .pg-item__date {
    width: auto;
    padding-right: 0;
    border-right: none;
  }

  .pg-item__side {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
